import { useIntl } from 'react-intl'

import { Box, Typography, useTheme } from '@themenu/design-system'

export const LegalLinks = (): JSX.Element => {
  const intl = useIntl()
  const theme = useTheme()
  const linkIntlPrefixes = [
    'sign_in_page.legal_links.legal_notice',
    'sign_in_page.legal_links.privacy_policy',
    'sign_in_page.legal_links.cgu',
    'sign_in_page.legal_links.cookies',
  ]
  return (
    <Box display="flex" flexDirection="row" justifyContent="space-around" alignItems="flex-end" width="100%" p={16}>
      {linkIntlPrefixes.map((linkIntlPrefix) => {
        const linkId = `${linkIntlPrefix}.link`
        const link = intl.formatMessage({ id: linkId })
        const linkPresent = link !== linkId
        const title = intl.formatMessage({ id: `${linkIntlPrefix}.title` })
        return (
          linkPresent && (
            <Typography
              key={linkIntlPrefix}
              variant="footnote"
              component="a"
              href={link}
              target="_blank"
              color={theme.colors.content.subdued}
              align="center"
              px={4}
            >
              {title}
            </Typography>
          )
        )
      })}
    </Box>
  )
}
